import { formatClock } from '../lib/format.ts';

/** Always visible when the server runs with SIMULATED_CLOCK: answers refer to that moment. */
export function SimulatedClock({ now }: { now: string }) {
  return (
    <div
      role="status"
      className="bg-gold-300 px-4 py-1.5 text-center text-sm font-semibold text-ink"
    >
      Reloj simulado: {formatClock(new Date(now))}
    </div>
  );
}
